import { ApplicationRootState } from 'redux-core/types';
import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectAdminMemberGroup = (state: ApplicationRootState) =>
    state.admin.memberGroup || initialState;

export const selectMemberGroupList = createSelector(
    selectAdminMemberGroup,
    (state) => state
);

export const selectAdminMemberGroupLoading = createSelector(
    selectAdminMemberGroup,
    (state) => state.loading
);

export const selectMemberGroupActiveTemplates = createSelector(
    selectAdminMemberGroup,
    (state) => state.activeTemplates
);
